import { BLOG_POSTS } from '@/constants/blogPosts'
import { BLOG_POST_PHOTO_COVERS } from '@/constants/blogPostPhotoCovers'

/** 统一 Blog 封面（public SVG，非旧站截图） */
export const BLOG_COVER_PATHS = {
	default: '/images/blog/covers/article-default.svg',
	hero: '/images/blog/covers/blog-hero.svg',
	categories: {
		'account-security': '/images/blog/covers/category-account.svg',
		troubleshooting: '/images/blog/covers/category-troubleshooting.svg',
		'updates-compatibility': '/images/blog/covers/category-updates.svg',
		'backup-migration': '/images/blog/covers/category-backup.svg',
		'features-settings': '/images/blog/covers/category-features.svg',
	},
}

/** 正文里已单独放首图时，详情顶栏不再重复封面 */
const NO_HEADER_COVER_SLUGS = new Set()

export function getCategoryCardImage(categoryId) {
	return BLOG_COVER_PATHS.categories[categoryId] || BLOG_COVER_PATHS.default
}

/** 列表与卡片用真实截图；详情顶栏同路径 */
export function getPostCoverSrc(slug) {
	const post = BLOG_POSTS[slug]
	if (post?.coverImage) return post.coverImage
	if (BLOG_POST_PHOTO_COVERS[slug]) return BLOG_POST_PHOTO_COVERS[slug]
	if (post) return `/images/blog/covers/articles/${slug}.svg`
	return BLOG_COVER_PATHS.default
}

export function shouldShowHeaderCover(slug) {
	return !NO_HEADER_COVER_SLUGS.has(slug)
}

export function getBlogHeroImage() {
	return BLOG_COVER_PATHS.hero
}
